import React from 'react';
import Modal from 'components/commons/modal/Modal2';
import Loading from 'components/commons/loading/Loading';
import Icon from 'components/commons/icon/Icon';

type SyncAccountAssetResultModalProps = {
  isShowModal: boolean;
  hideModal: () => void;
  resultCode: number;
  isLoading: boolean;
};

const SyncAccountAssetResultModal: React.FC<SyncAccountAssetResultModalProps> = props => {
  const title = (resultCode: number, isLoading: boolean) => {
    if (isLoading) {
      return <>しばらくお待ちください</>;
    }
    if (resultCode === 0) {
      return (
        <>
          データ更新を開始します
          <br />
          完了までしばらくお待ちください
        </>
      );
    } else if (resultCode === 1) {
      return <>定期更新が完了するまでお待ちください</>;
    } else if (resultCode === 2) {
      return <>口座についてお問合せください</>;
    } else if (resultCode === 3) {
      return <>既に更新処理を受け付けております</>;
    }
    return <>更新できませんでした</>;
  };
  const message = (resultCode: number, isLoading: boolean) => {
    if (isLoading) {
      return null;
    }
    if (resultCode === 0) {
      return (
        <>
          <div>
            完了には10分〜数時間かかる場合があります。
            <br />
            連携先の証券会社がメンテナンス等で接続できない場合は、データ更新は翌営業日の夕方18：00以降となります。
          </div>
          <div className="mt-4">
            翌営業日以降もデータが更新されない場合はお問い合わせください。
          </div>
        </>
      );
    } else if (resultCode === 1) {
      return (
        <>
          <div>
            アセプラが定期更新中のため以下の時間帯は更新ができません。定期更新完了後に自動でデータが更新されます。
          </div>
          <div className="mt-4">
            【定期更新中の時間】
            <br />
            ①6:00〜10:00
            <br />
            ②15:00〜20:00
          </div>
          <div className="mt-4 text-xs">
            <div>※日曜日は除きます。</div>
            <div>※土曜日は①の時間帯だけ定期更新が発生します。</div>
          </div>
        </>
      );
    } else if (resultCode === 2) {
      return (
        <>
          <div>しばらく経っても解消しない場合はお問い合わせください。</div>
          <div className="mt-4 text-blue-700">
            <a
              href="https://support.minkabu.jp/hc/ja/requests/new?ticket_form_id=360002511233"
              target="_blank"
              rel="noopener noreferrer">
              <div className="flex flex-row">
                <span>お問い合わせ</span>
                <i className="icon-external-link ml-2 text-lg" />
              </div>
            </a>
          </div>
        </>
      );
    } else if (resultCode === 3) {
      return (
        <>
          <div>
            再度更新を行う場合は、1時間程度経ってから更新ボタンを押してください。
          </div>
          <div className="mt-4">
            翌営業日もデータが更新されない場合はお問い合わせください。
          </div>
          <div className="mt-4 text-blue-700">
            <a
              href="https://support.minkabu.jp/hc/ja/requests/new?ticket_form_id=360002511233"
              target="_blank"
              rel="noopener noreferrer">
              お問い合わせ
            </a>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div>
            しばらくお待ちいただいても解消しない場合は、お手数をおかけしますがこちらからお問い合わせをお願いいたします。
          </div>
          <div className="mt-4 text-blue-700">
            <a
              href="https://support.minkabu.jp/hc/ja/requests/new?ticket_form_id=360002511233"
              target="_blank"
              rel="noopener noreferrer">
              お問い合わせ
            </a>
          </div>
        </>
      );
    }
  };

  return (
    <Modal
      isShow={props.isShowModal}
      close={props.hideModal}
      closeOnClickOutsideWindow>
      <div className="p-4">
        <div className="flex flex-row">
          {!(props.isLoading || props.resultCode === 0) && (
            <Icon
              name="alert"
              className="flex items-center h-5 text-red pr-2"
            />
          )}
          <div className="text-base font-bold">
            {title(props.resultCode, props.isLoading)}
          </div>
          <div
            className="icon-close ml-auto text-gray-500 text-2xl cursor-pointer"
            onClick={props.hideModal}
          />
        </div>
        <div className="mt-3 text-sm">
          {message(props.resultCode, props.isLoading)}
        </div>
        {props.isLoading ? null : (
          <div
            onClick={props.hideModal}
            className="flex justify-center text-blue-700 m-1 p-2 text-sm cursor-pointer">
            閉じる
          </div>
        )}
        {props.isLoading && (
          <div className="my-20 flex justify-center items-center">
            <Loading
              loading={true}
              circularLoading={true}
              style={{
                backgroundColor: 'transparent',
              }}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default SyncAccountAssetResultModal;
